'use-strict'

const _lsId = 'fn_fc_i';

class HomeModal {

  constructor() {

    if ($(window).width() > 576) {
      if (this.getLS() == null) {
        this.setLS();
        this.showModal();
      }
    }
  }

  getLS() {
    return localStorage.getItem(_lsId);
  }

  setLS() {
    localStorage.setItem(_lsId, 1);
  }

  showModal() {
    $('#ifVideo').attr('src', 'https://www.youtube.com/embed/jDCUC7XvtcI')
    $('#modalVideo').modal();

    $('#modalVideo').on('hidden.bs.modal', function () {
      $('#ifVideo').attr('src', '');
    });
  }
}

export default HomeModal



// WEBPACK FOOTER //
// ./scripts/home-modal/home-modal.js